module.exports = __webpack_public_path__ + "img/event-session-thematique2.5de0ae8.jpg";